import { calculateOffset } from 'src/app/common/app.helpers';
import FieldsConstants from 'src/app/common/fields.constants';
import { PaginationResolver } from 'src/app/interfaces/pagination.interface';
import { SearchState } from 'src/app/interfaces/search.interface';

export const initialPaginationState: () => SearchState = () => ({
  pagination: { currentPage: 1, totalItemsCount: 0 },
});

export const initialResolver: () => PaginationResolver = () => ({
  state: initialPaginationState(),
  onPageChanged: (_page: number) => {
    // Simply ignore
  },
});

export function defineCallParams(
  previousState: SearchState,
  currentState: SearchState,
): [offset: number, limit: number] {
  const defaultParams: [offset: number, limit: number] = [0, FieldsConstants.SEARCH_DEFAULT_RESULTS_COUNT];

  if (!currentState || !currentState.pagination) {
    return defaultParams;
  }

  const limit: number = currentState.pagination.limit || FieldsConstants.SEARCH_DEFAULT_RESULTS_COUNT;
  const offset: number = calculateOffset(previousState, currentState, limit, false);

  return offset > -1 ? [offset, limit] : defaultParams;
}
